// Site-wide constants shared across pages. CONTACT_EMAIL is the guest-facing
// inbox surfaced in the footer, the booking sidebar, and the calendar's
// degraded state — the mailbox (or a forward to it) must exist before launch.
export const CONTACT_EMAIL = 'stay@charleston.vacations';
